import React from "react";
import "./Footer.css";
import logo from "../Assets/Logo/onlylogosmc.png";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="Footer">
      <div className="container">
        <div className="row">
          {/* Left Section - Logo & Description */}
          <div className="col-lg-3 col-md-6">
            <div className="Footer-brand">
              <img
                src={logo}
                alt="HrHub Logo"
                className="Footer-logo"
                style={{ height: "100px" }}
              />
            </div>
            <p className="Footer-description">
              Srimathi Manpower Consultancy<br></br> Reg No: 1869/2016
              <br></br>
              MSME : TN08D0020201
              <br></br>
              GST : 33AIZPT7902P1Z5
            </p>
            <div className="Footer-social">
              <a href="#" className="Footer-social-btn">
                <FaFacebookF />
              </a>
              <a href="#" className="Footer-social-btn">
                <FaLinkedinIn />
              </a>
              <a href="#" className="Footer-social-btn">
                <FaTwitter />
              </a>
              <a href="#" className="Footer-social-btn">
                <FaYoutube />
              </a>
            </div>
          </div>

          {/* Contact Section */}
          <div className="col-lg-2 col-md-6 mt-5">
            <h4 className="Footer-heading">Reach Us</h4>
            <ul className="Footer-list">
              <li>
                <a
                  href="https://www.google.com/maps?q=13/1+Redhills+Road,+Ramdass+Nagar,+Kolathur,+Chennai+-+600099"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <span className="Footer-icon">📍</span> #13/1, Redhills Road,
                  Ramdass Nagar, Kolathur, Chennai - 6000 99.
                </a>
              </li>
            </ul>
          </div>

          {/* Support Section */}
          <div className="col-lg-3 col-md-6 mt-5">
            <h4 className="Footer-heading">Get In Touch with Us</h4>
            <ul className="Footer-list">
              <li>
                <span className="Footer-icon">
                  <i className="fa fa-mobile-alt" aria-hidden="true"></i>
                </span>
                <a
                  href="tel:+919840562357"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  +91 98400 88046
                </a>
              </li>
              <li>
                <span className="Footer-icon">
                  <i className="fa fa-phone" aria-hidden="true"></i>
                </span>
                <a
                  href="tel:+04446146838"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  044 - 4614 6838
                </a>
              </li>

              <li>
                <span className="Footer-icon">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </span>
                <a
                  href="mailto:info@srimathiconsultancy.com"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  info@srimathiconsultancy.com
                </a>
              </li>
              <li>
                <span className="Footer-icon">
                  <i className="fa fa-globe" aria-hidden="true"></i>
                </span>
                <a
                  href="http://www.srimathiconsultancy.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  www.srimathiconsultancy.com
                </a>
              </li>
            </ul>
          </div>

          {/* Information Section */}
          <div className="col-lg-2 col-md-6 mt-5">
            <h4 className="Footer-heading">Quick Links</h4>
            <ul className="Footer-list">
              <a
                href="/ourservices"
                style={{ textDecoration: "none", color: "white" }}
              >
                {" "}
                <li>Our Services</li>
              </a>
              <a
                href="/privacypolicy"
                style={{ textDecoration: "none", color: "white" }}
              >
                {" "}
                <li>Privacy Policy</li>
              </a>
              <a
                href="/terms"
                style={{ textDecoration: "none", color: "white" }}
              >
                <li>Terms & Conditions</li>
              </a>
              <a
                href="/agreements"
                style={{ textDecoration: "none", color: "white" }}
              >
                {" "}
                <li>Service Agreements</li>
              </a>
            </ul>
          </div>
          {/* Information Section */}
          <div className="col-lg-2 col-md-6 mt-5">
            <h4 className="Footer-heading">We Are Hiring</h4>
            <ul className="Footer-list">
              <a
                href="/candidateform"
                style={{ textDecoration: "none", color: "white" }}
              >
                {" "}
                <li>Apply Now</li>
              </a>
              <a
                href="/userfeedback"
                style={{ textDecoration: "none", color: "white" }}
              >
                {" "}
                <li>Write Feedback</li>
              </a>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="Footer-bottom">
          <p>© Srimathi Manpower Consultancy. All rights Reserved 2025</p>
          <div className="Footer-payment">
            <p>
              Design and Developed By{" "}
              <a
                href="https://idlbay.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "#BD212F" }}
              >
                IDLBAY Private Limited
              </a>
            </p>
          </div>
          <a href="#" className="Footer-scroll-top">
            ⬆
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
